import { IOrderDetailsApiDto } from '../api.types'
import { EOrderStatus, EOrderStatusName } from '../../orderStatus'

export const getFiatOrderDetailsApiRespMock: IOrderDetailsApiDto = {
    refund_address: null,
    amount_base: '0.02286140',
    is_default_rule: true,
    unique_reference: 'OZVW7P',
    amount_quote: '500.00000000',
    pair: {
        name: 'BTCEUR',
        base: {
            code: 'BTC',
            name: 'bitcoin',
            min_confirmations: 2,
            is_crypto: true,
            minimal_amount: '0.00100000',
            maximal_amount: '100.00000000',
            is_base_of_enabled_pair: true,
            is_quote_of_enabled_pair: true,
            has_enabled_pairs: true,
            is_base_of_enabled_pair_for_test: true,
            is_quote_of_enabled_pair_for_test: true,
            has_enabled_pairs_for_test: true,
            withdrawal_fee: '0.00050000',
            extra_id: null,
        },
        quote: {
            code: 'EUR',
            name: 'EUR',
            min_confirmations: null,
            is_crypto: false,
            minimal_amount: '10.00000000',
            maximal_amount: '20000.00000000',
            is_base_of_enabled_pair: false,
            is_quote_of_enabled_pair: true,
            has_enabled_pairs: true,
            is_base_of_enabled_pair_for_test: false,
            is_quote_of_enabled_pair_for_test: true,
            has_enabled_pairs_for_test: true,
            withdrawal_fee: '0.00000000',
            extra_id: null,
        },
        fee_ask: 0.04,
        fee_bid: 0.04,
    },
    withdraw_address: {
        type: 'W',
        name: '',
        address: '3EGjwPQdF1FYEGURWR7oskpFZnx1TnKPps',
        currency_code: 'BTC',
        destination_tag: null,
        extra_id: null,
        memo: null,
    },
    deposit_address: null,
    created_on: '2020-12-23T08:33:22.453155Z',
    from_default_rule: false,
    payment_window: 15,
    payment_deadline: '2020-12-23T08:48:22.453155Z',
    kyc_deadline: '2020-12-23T10:36:52.204954Z',
    status_name: [[EOrderStatus.INITIAL, EOrderStatusName.INITIAL]],
    transactions: [
        {
            created_on: '2020-12-23T09:06:06.427290Z',
            modified_on: '2020-12-23T09:19:06.797806Z',
            type: 'W',
            address_to: 26204,
            tx_id: '95bfbb4195ae676c75a26f4f69483d29e813e400fb39ec7f37326b8dd46d3a6e',
            confirmations: 2,
            amount: '0.02286140',
            is_verified: false,
            is_completed: false,
            time: '2020-12-23T09:06:06.426677Z',
            currency: 'BTC',
        },
    ],
    referral_code: [
        {
            code: 'RRS4YUVGSWZ',
            created_on: '2020-12-23T08:32:45.697597Z',
            modified_on: '2020-12-23T08:32:45.697633Z',
        },
    ],
    withdrawal_fee: 0.0005,
    withdrawal_fee_quote: 10.059327522895,
    user_provided_amount: 1,
    amount_usd: 609.5531940024518,
    amount_btc: 0.0258626315149,
    amount_eur: 500.0,
    amount_quote_fee: 30.0,
    payment_url: null,
    display_refund_address: false,
    price: {
        rate: 20118.65504579,
        rate_usd: 23568.8775,
        rate_btc: 1.0,
        rate_eur: 19332.91280556,
    },
}
